import { Component, ViewChild, OnInit } from '@angular/core'
import { ModalDirective } from 'ngx-bootstrap/modal/modal.directive'
import { FormGroup, FormBuilder, Validators, AbstractControl, ValidatorFn } from '@angular/forms'
import { AuthenticationService } from 'src/app/core/authentication/authentication.service'
import { first, finalize } from 'rxjs/operators'
import notify from 'devextreme/ui/notify'
import { EncryptionService } from 'src/app/core/services/encryption.service'

@Component({
  selector: 'app-reset-password',
  templateUrl: './reset-password.component.html',
  styleUrls: ['./reset-password.component.scss'],
})
export class ResetPasswordComponent implements OnInit {
  valForm: FormGroup

  @ViewChild('modalResetPassword', { static: true }) modalResetPassword: ModalDirective
  loading: boolean
  passwordRules: ''
  constructor(
    private fb: FormBuilder,
    private authenticationService: AuthenticationService,
    private encryptionService: EncryptionService
  ) {}

  showModal() {
    this.modalResetPassword.show()
  }

  ngOnInit() {
    const username = this.authenticationService.getUsername()
    this.getPasswordRules()
    this.valForm = this.fb.group({
      username: [{ value: username, disabled: true }, Validators.required],
      password: [null, Validators.required],
      newPassword: [null],
      confirmNewPassword: [null, this.matchingPasswords()],
    })
  }

  getPasswordRules() {
    this.authenticationService
      .getPasswordRules()
      .pipe(first())
      .subscribe((response: any) => {
        this.passwordRules = response.passwordRules
      })
  }

  matchingPasswords(): ValidatorFn {
    return (control: AbstractControl): { [key: string]: any } | null => {
      let isValid = false
      if (this.valForm == null) {
        return null
      }
      const password = this.getControl('newPassword')
      if (password.value === control.value) {
        isValid = true
      }
      return isValid
        ? null
        : {
            matchingPasswords: true,
          }
    }
  }

  onSubmit() {
    const confirmNewPassword = this.getControl('confirmNewPassword')
    confirmNewPassword.updateValueAndValidity()

    if (!this.valForm.valid) {
      Object.keys(this.valForm.controls).forEach((field) => {
        const formControl = this.valForm.controls[field]
        formControl.markAsTouched({ onlySelf: true })
      })
      return
    }
    const username = this.encryptionService.encrypt(this.authenticationService.getUsername())
    this.authenticationService
      .changePassword(
        username,
        this.encryptionService.encrypt(this.valForm.value.password),
        this.encryptionService.encrypt(this.valForm.value.newPassword),
        this.encryptionService.encrypt(this.valForm.value.confirmNewPassword)
      )
      .pipe(
        first(),
        finalize(() => (this.loading = false))
      )
      .subscribe(
        (response) => {
          notify(response.message, 'success', 600)
          this.modalResetPassword.hide()
        },
        (response) => notify(response.error.message, 'error', 600)
      )
  }
  getControl(name: string) {
    return this.valForm.get(name)
  }
}
